import ArrowForwardIcon from "@mui/icons-material/ArrowForwardRounded";
import { Button } from "@mui/material";
import { Link } from "react-router";

interface Props {
  to?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const ViewAllWidgetButton = ({ to, onClick, disabled }: Props) => {
  if (to !== undefined) {
    return (
      <Button
        variant="text"
        color="primary"
        endIcon={<ArrowForwardIcon />}
        component={Link}
        to={to}
        disabled={disabled}
      >
        View all
      </Button>
    );
  }

  return (
    <Button variant="text" color="primary" endIcon={<ArrowForwardIcon />} onClick={onClick} disabled={disabled}>
      View all
    </Button>
  );
};

export default ViewAllWidgetButton;
